import { ProductForm, Drawer } from "./theme.js";

class UpsellForm extends ProductForm {
  constructor() {
    super();
    this._onUpsellOptionClick = this._onUpsellOptionClick.bind(this);
  }
  connectedCallback() {
    this.upsellOptions = this.querySelectorAll("upsell-option");
    this.upsellInput = this.querySelector('input[id="upsell-input"]');

    this.upsellOptions.forEach((option) => {
      option.addEventListener("click", this._onUpsellOptionClick);
    });

    this.submitButtons = Array.from(this.elements).filter(
      (button) => button.type === "submit"
    );
  }

  _onUpsellOptionClick(event) {
    this.upsellOptions.forEach((opt) => opt.classList.remove("active"));
    event.target.closest("upsell-option").classList.add("active");
    this.upsellInput.value =
      event.target.closest("upsell-option").dataset.variantId;
    this.closest("upsell-popup").querySelector("#default-title").classList.add("hidden");
    this.closest("upsell-popup").querySelector("#alt-title").classList.remove("hidden");
    this.submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
  }
}

if (!window.customElements.get("upsell-form")) {
  window.customElements.define("upsell-form", UpsellForm, { extends: "form" });
}

class ExtendedProductForm extends ProductForm {
  constructor() {
    super();
    this._onSubmit = this._onSubmit.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this.buyBox = this.closest(".product-info");
    this.subscriptionCheckbox = this.buyBox.querySelector(
      ".subscription-checkbox input"
    );
    this.subscriptionAddon = this.buyBox.querySelector(".subscription-addon");
    this.subscriptionProductId =
      this.subscriptionAddon?.dataset.subscriptionProductId;
    this.subscriptionPlanId =
      this.subscriptionAddon?.dataset.subscriptionPlanId;
  }

  async _onSubmit(event) {
    event.preventDefault();

    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }

    const submitButtons = Array.from(this.elements).filter(
      (button) => button.type === "submit"
    );
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });

    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set(
      "sections_url",
      `${Shopify.routes.root}variants/${this.id.value}`
    );

    try {
      // Add main product to cart
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      let responseJson = await response.json();

      if (response.ok) {
        // If subscription checkbox exists and is checked, add subscription product
        if (
          this.subscriptionCheckbox &&
          this.subscriptionCheckbox.checked &&
          this.subscriptionProductId
        ) {
          const subscriptionResponse = await fetch(
            `${Shopify.routes.root}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: this.subscriptionProductId,
                    quantity: 1,
                    selling_plan: this.subscriptionPlanId,
                  },
                ],
              }),
            }
          );

          const subscriptionResponseJson = await subscriptionResponse.json();

          // Merge the subscription item with the main product items
          if (subscriptionResponse.ok) {
            if (Array.isArray(responseJson.items)) {
              responseJson.items.push(subscriptionResponseJson.items[0]);
            } else {
              responseJson = {
                ...responseJson,
                ...subscriptionResponseJson,
              };
            }
          }
        }

        // Rest of the original _onSubmit logic
        if (
          window.themeVariables.settings.cartType === "page" ||
          window.themeVariables.settings.pageType === "cart"
        ) {
          return (window.location.href = `${Shopify.routes.root}cart`);
        }

        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        cartContent["sections"] = responseJson["sections"];

        this.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty("items")
                ? responseJson["items"]
                : [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent,
            },
          })
        );
      } else {
        this.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"],
            },
          })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (error) {
      console.error("Error:", error);
      this.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: "An error occurred while adding items to the cart.",
          },
        })
      );
    } finally {
      submitButtons.forEach((submitButton) => {
        submitButton.removeAttribute("disabled");
        submitButton.removeAttribute("aria-busy");
      });
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }
}

if (!window.customElements.get("product-addon-form")) {
  window.customElements.define("product-addon-form", ExtendedProductForm, {
    extends: "form",
  });
}

// js/sections/newsletter-popup.js
var UpsellPopup = class extends Drawer {
  connectedCallback() {
    super.connectedCallback();
  }
  get initialFocus() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  async show() {
    this.style.display = "block";
    return super.show();
  }
};
if (!window.customElements.get("upsell-popup")) {
  window.customElements.define("upsell-popup", UpsellPopup);
}


document.addEventListener('DOMContentLoaded', function() {
  const subscriptionOptions = document.querySelectorAll('.shopify_subscriptions_app_block_label');
  subscriptionOptions.forEach(option => {
    const radio = option.querySelector('input[type="radio"]');
    const subOptions = option.querySelector('.shopify_subscriptions_app_block_label_children');
    radio.addEventListener('change', function() {
    });
    let clickElement = option.querySelector('.shopify_subscriptions_purchase_option_wrapper') || option ;
    clickElement.addEventListener('click', function() {

      radio.click();
      radio.dispatchEvent(new Event('change', { bubbles: true }));

      // Hide all sub-options
      document.querySelectorAll('.shopify_subscriptions_app_block_label_children').forEach(el => {
        el.style.display = 'none';
      });
      
      // Show sub-options for the selected option
      subOptions.style.display = 'block';
    });

  });
  
  // Show sub-options for initially selected option
  const initiallySelected = document.querySelector('.shopify_subscriptions_app_block_label input[type="radio"]:checked');
  if (initiallySelected) {
    const subOptions = initiallySelected.closest('.shopify_subscriptions_app_block_label').querySelector('.shopify_subscriptions_app_block_label_children');
    if (subOptions) {
      subOptions.style.display = 'block';
    }
  }
  
});
